import React, { useState } from 'react';

const CreateTemplateModal = ({ templates, onClose, onCreate }) => {
    const [mode, setMode] = useState('blank'); // blank, duplicate, import
    const [selectedTemplate, setSelectedTemplate] = useState('');
    const [importText, setImportText] = useState('');

    const handleCreate = () => {
        if (mode === 'blank') {
            onCreate('blank');
        } else if (mode === 'duplicate' && selectedTemplate) {
            const source = templates.find((t) => t.id === selectedTemplate);
            onCreate('duplicate', { sourceTemplate: source });
        } else if (mode === 'import' && importText.trim()) {
            onCreate('import', { text: importText.trim() });
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Create Template</h2>
                    <button className="modal-close" onClick={onClose}>
                        <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <div className="modal-body">
                    <div className="form-group">
                        <label>Start from</label>
                        <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
                            <button
                                className={`template-btn ${mode === 'blank' ? 'primary' : 'secondary'}`}
                                onClick={() => setMode('blank')}
                                style={{ flex: 1 }}
                            >
                                Blank Template
                            </button>
                            <button
                                className={`template-btn ${mode === 'duplicate' ? 'primary' : 'secondary'}`}
                                onClick={() => setMode('duplicate')}
                                style={{ flex: 1 }}
                            >
                                Duplicate Existing
                            </button>
                            <button
                                className={`template-btn ${mode === 'import' ? 'primary' : 'secondary'}`}
                                onClick={() => setMode('import')}
                                style={{ flex: 1 }}
                            >
                                Import Text
                            </button>
                        </div>
                    </div>

                    {mode === 'duplicate' && (
                        <div className="form-group">
                            <label>Select template to duplicate</label>
                            <select
                                value={selectedTemplate}
                                onChange={(e) => setSelectedTemplate(e.target.value)}
                            >
                                <option value="">Choose a template...</option>
                                {templates.map((t) => (
                                    <option key={t.id} value={t.id}>
                                        {t.title}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    {mode === 'import' && (
                        <div className="form-group">
                            <label>Paste your document text</label>
                            <textarea
                                value={importText}
                                onChange={(e) => setImportText(e.target.value)}
                                placeholder="Paste the text content of your document here..."
                                rows={8}
                            />
                        </div>
                    )}
                </div>

                <div className="modal-footer">
                    <button className="editor-btn secondary" onClick={onClose}>
                        Cancel
                    </button>
                    <button
                        className="editor-btn primary"
                        onClick={handleCreate}
                        disabled={
                            (mode === 'duplicate' && !selectedTemplate) ||
                            (mode === 'import' && !importText.trim())
                        }
                    >
                        Create Template
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreateTemplateModal;
